import { diaryMotion } from './diary-layout'

// The phone Diary's stops snap into place (design B, Liam, 23 Oct 2026: "We could get really cool click into place
// animation cus its linked?"). Taken just before the day is drawn again, settled just after: a stop that moved slides
// from where it was along the line, a stop whose number changed pops its new number, and a stop marked done slides down
// the line into "Done" and fades while Done's tick pops. Short (docs/ANIMATION-STANDARD.md: 120–320ms, ease-out) and
// none at all on a phone set to reduce motion (diaryMotion). A reorder keeps its own settle (diaryOrderSettle).

interface Stop { top: number; n: string; rect: DOMRect; row: HTMLElement }
export interface StopsBefore { date: string; stops: Map<number, Stop> }

const stopRows = (card: HTMLElement): HTMLElement[] =>
  (Array.from(card.children) as HTMLElement[]).filter((c) => !!c.classList?.contains('clean-row') && !!c.dataset?.cleanId)

export function captureStops(root: HTMLElement, date: string): StopsBefore | null {
  const card = root.querySelector<HTMLElement>(`.day-card[data-date="${date}"]`)
  if (!card || typeof card.getBoundingClientRect !== 'function') return null
  const stops = new Map<number, Stop>()
  for (const row of stopRows(card)) {
    const rect = row.getBoundingClientRect()
    if (rect.height) stops.set(Number(row.dataset.cleanId), { top: rect.top, n: row.querySelector('.diary-row-n')?.textContent ?? '', rect, row })
  }
  return stops.size ? { date, stops } : null
}

export function settleStops(root: HTMLElement, before: StopsBefore): void {
  const card = root.querySelector<HTMLElement>(`.day-card[data-date="${before.date}"]`)
  if (!card) return
  const still = new Set<number>()
  for (const row of stopRows(card)) {
    const id = Number(row.dataset.cleanId)
    still.add(id)
    const was = before.stops.get(id)
    if (!was) continue
    const distance = Math.max(-240, Math.min(240, was.top - row.getBoundingClientRect().top))
    if (Math.abs(distance) > 1) diaryMotion(row, [{ transform: `translateY(${distance}px)` }, { transform: 'translateY(0)' }], 220)
    const n = row.querySelector<HTMLElement>('.diary-row-n')
    if (n && was.n && n.textContent !== was.n) diaryMotion(n, [{ transform: 'scale(1.35)' }, { transform: 'scale(1)' }], 240)
  }
  const completed = card.querySelector<HTMLElement>(':scope > .diary-completed')
  const summary = completed?.querySelector<HTMLElement>(':scope > summary')
  if (!completed || !summary) return
  const done = new Set(Array.from(completed.querySelectorAll<HTMLElement>('[data-clean-id]')).map((r) => Number(r.dataset.cleanId)))
  let landed = false
  for (const [id, was] of before.stops) {
    if (still.has(id) || !done.has(id)) continue
    landed = true
    // The stop as it was, laid over the page where it stood, sliding down to Done and fading; never tappable.
    const ghost = was.row
    ghost.setAttribute('aria-hidden', 'true')
    ghost.inert = true
    Object.assign(ghost.style, { position: 'fixed', left: `${was.rect.left}px`, top: `${was.rect.top}px`, width: `${was.rect.width}px`, margin: '0', zIndex: '30', pointerEvents: 'none', background: '#fff' })
    document.body.append(ghost)
    const to = summary.getBoundingClientRect().top - was.rect.top
    const slide = diaryMotion(ghost, [{ transform: 'translateY(0)', opacity: 1 }, { transform: `translateY(${to}px) scale(.96)`, opacity: 0 }], 320)
    if (slide) slide.addEventListener('finish', () => ghost.remove())
    else ghost.remove()
  }
  if (landed) {
    completed.classList.add('diary-completed-landed')
    window.setTimeout(() => completed.classList.remove('diary-completed-landed'), 420)
  }
}
